import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

interface SideNavContextValue {
  readonly expanded: boolean;
  readonly onLinkClick?: () => void;
}

const SideNavContext = createContext<SideNavContextValue | undefined>(
  undefined,
);

export function SideNavProvider({
  expanded,
  onLinkClick,
  children,
}: PropsWithChildren<SideNavContextValue>) {
  const value = useMemo(
    () => ({ expanded, onLinkClick }),
    [expanded, onLinkClick],
  );

  return (
    <SideNavContext.Provider value={value}>{children}</SideNavContext.Provider>
  );
}

export function useSideNavExpanded(): boolean {
  return useContext(SideNavContext)?.expanded ?? true;
}

export function useSideNavLinkClick(): (() => void) | undefined {
  return useContext(SideNavContext)?.onLinkClick;
}
